export const CONFIG_FOR_STRING_POSTS = {
    headers: {
        'Content-Type': 'application/json',
    },
    transformRequest: [(data:any) => data], // prevent axios from auto-transforming it again
};